(function () {
  'use strict';
  try {
    var qs = window.location.search;
    var hash = window.location.hash;
    var isVoliiReturn =
      qs.indexOf('volii_signup=1') !== -1 ||
      (qs.indexOf('customer_posted=true') !== -1 &&
        (hash === '#volii-email-capture' ||
          hash === '#Volii-Form' ||
          sessionStorage.getItem('vycora_volii_pending') === '1' ||
          localStorage.getItem('vycora_volii_pending') === '1'));

    if (!isVoliiReturn) return;

    var y = parseInt(
      sessionStorage.getItem('vycora_volii_scroll') ||
        localStorage.getItem('vycora_volii_scroll'),
      10
    );
    if (isNaN(y)) y = 0;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var url = new URL(window.location.href);
    url.searchParams.delete('customer_posted');
    url.searchParams.delete('volii_signup');
    url.hash = '';
    var cleanSearch = url.searchParams.toString();
    history.replaceState(null, '', url.pathname + (cleanSearch ? '?' + cleanSearch : ''));

    var lock = function () {
      window.scrollTo(0, y);
    };

    document.addEventListener(
      'focusin',
      function (e) {
        var t = e.target;
        if (t && t.id === 'ContactFooter-success') {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (t.blur) t.blur();
          lock();
        }
      },
      true
    );

    lock();
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        var footerSuccess = document.getElementById('ContactFooter-success');
        if (footerSuccess) {
          footerSuccess.removeAttribute('autofocus');
          var msg = footerSuccess.closest('.newsletter-form__message--success');
          if (msg) msg.setAttribute('hidden', '');
        }
        lock();
      },
      { once: true }
    );
    window.addEventListener('load', lock, { once: true });

    var frames = 0;
    (function tick() {
      lock();
      if (++frames < 24) requestAnimationFrame(tick);
    })();
  } catch (e) {}
})();
